export default function PHP_header_register_callback() {
  return (
    <div>
      <h1>PHP_header_register_callback</h1>
    </div>
  );
}
